import UploadNewsForm from "../../UploadNewsForm";
import { createOpinionThoughts } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewOpinionThoughts() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createOpinionThoughts(title, description, image);
      if (result) {
        navigate("/opinion-thoughts/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Opninion and Thoughts"}
          breadCrumbText={"Create New"}
          goBackLink={"/opinion-thoughts/all"}
        />
      </Container>
    </>
  );
}
